"use client";

import { InformationCard } from "@/components/shared/InformationCard";
import { useAlert } from "@/store/alert/alert";

export const AlertQueue = () => {
  const alertQueue = useAlert((state) => state.alertQueue);
  const removeAlert = useAlert((state) => state.remove);

  if (alertQueue.length === 0) {
    return null;
  }

  return (
    <div className="absolute inset-x-0 top-3 z-1200 flex w-full flex-col items-center gap-3 px-3 sm:px-4">
      {alertQueue.map((alert) => (
        <InformationCard
          key={alert.id}
          id={alert.id}
          color={alert.type}
          content={alert.message}
          onClose={() => removeAlert(alert.id)}
          onClick={alert.onClick}
          className="w-full max-w-[420px]"
        />
      ))}
    </div>
  );
};
